import * as types from './types'
import DirectusApi from '../../lib/directus.api'

export const loadNewsList = () => async (dispatch: Function, state: Function) => {
  // const idToken = firebase.auth().currentUser?.getIdToken()
  // if (!idToken) {
  //   return Promise.reject()
  //   // return dispatch(handleError({ code: 'auth/no-access-token', message: 'Error' }))
  // }

  try {
    const { data: { data: result } } = await DirectusApi.get('/items/news', {
      params: {
        sort: "-date"
      }
    })
    dispatch({
      type: types.GET_NEWS_LIST,
      news: result,
    })
    return result
  }
  catch (reason) {
    throw new Error(reason.message)
  }
}

export const loadNewsDetail = ({ newsId }: { newsId: string }) => async (dispatch: Function, state: Function
) => {
  try {
    const { data: { data: result } } = await DirectusApi.get(`/items/news/${newsId}`)

    dispatch({
      type: types.GET_NEWS_ARTICLE,
      newsId,
      newsArticle: result,
    })
    return result
  } catch (reason) {
    throw new Error(reason.message)
  }
}
